import style from "./FurnitureImage.module.scss"

const { imageArea, placeholder } = style

type Props = {
	imageUrl?: string | null
	isCountertop: boolean
	hasModelNumber: boolean
	/**
	 * An "Other" item — no category, and therefore no model number to take a catalogue image from.
	 * Its own message rather than the countertop one, because the two are different product
	 * decisions that happen to look alike.
	 */
	isOther?: boolean
	/**
	 * A custom object (#1346 / #1371). Its model number is a drawing-local definition with no
	 * catalogue entry behind it, so there is no image to show and never will be — a different
	 * statement from the countertop and "other category" ones, which is why it gets its own branch
	 * rather than reusing either of theirs.
	 */
	isCustom?: boolean
	/**
	 * Explicit placeholder copy, overriding every branch below. The batch panel (REQ-403) needs it
	 * because its reasons for having no preview are its own — a mixed-type selection, or cabinets
	 * that don't agree on one model number — and none of them is derivable from a single object.
	 * `null` means "no reason, show the image".
	 */
	message?: string | null
}

export const FurnitureImage = ({
	imageUrl,
	isCountertop,
	hasModelNumber,
	isOther = false,
	isCustom = false,
	message,
}: Props) => {
	if (message) {
		return (
			<div className={imageArea}>
				<p className={placeholder}>{message}</p>
			</div>
		)
	}

	if (isCountertop) {
		return (
			<div className={imageArea}>
				<p className={placeholder}>Images are not supported for countertop</p>
			</div>
		)
	}

	if (isCustom) {
		return (
			<div className={imageArea}>
				<p className={placeholder}>Images are not supported for custom object</p>
			</div>
		)
	}

	if (isOther) {
		return (
			<div className={imageArea}>
				<p className={placeholder}>Images are not supported for other category</p>
			</div>
		)
	}

	if (imageUrl) {
		return (
			<div className={imageArea}>
				<img src={imageUrl} alt="Object" />
			</div>
		)
	}

	return (
		<div className={imageArea}>
			<p className={placeholder}>
				{hasModelNumber ? "No image available" : "The image will appear once model number is selected"}
			</p>
		</div>
	)
}
